import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { Toaster } from "react-hot-toast";
import { SWRConfig } from "swr";
import swrFetcher from "./utils/swrFetcher";
// import "./firebase-messaging-sw.js";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://7e826451d0e95d05ce4e11888fae098d@o4509033424027648.ingest.us.sentry.io/4509033556213760",
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <SWRConfig value={{ fetcher: swrFetcher, keepPreviousData: true }}>
      <App />
      <Toaster
        toastOptions={{ style: { background: "#363636", color: "#fff", fontWeight: "bold" } }}
      />
    </SWRConfig>
  </React.StrictMode>,
);
